import { LocalStorageService } from './../../_services/local-storage.service';
import { Router } from '@angular/router';
import { TalentpoolService } from './../../_services/talentpool.service';
import { SearchtoolboxService } from './../../_services/searchtoolbox.service';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateService } from 'src/app/_services/candidate.service';
import { Observable, Subject } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-create-candidate',
  templateUrl: './create-candidate.component.html',
  styleUrls: ['./create-candidate.component.scss']
})
export class CreateCandidateComponent implements OnInit {

  candidate_form: FormGroup;
  successMessage: string;
  errorMessage: string;
  jobtitlearraylist: any;
  locationarraylist: any;
  companyarraylist: any;
  joblist: any;
  companylist: any;
  locationlist: any;
  parentSubject: Subject<any> = new Subject();
  sourcelist = GlobalService.SourceList;
  createcandidate_form:boolean = true
  talentvalue: string = null;
  pipeline_list = GlobalService.PipelineStatus;
  autocomplete_company:boolean = true
  filesizeExceeded: boolean = false;

  @Input() events: Observable<void>;
  @ViewChild('successModal') successModal: TemplateRef<any>;
  @ViewChild('errorModal') errorModal: TemplateRef<any>;
  @ViewChild('duplicatecandidate') duplicatecandidate: TemplateRef<any>;
  
  duplicatecandidateid: any;
  talentpoolname: string;
  talentpoolslist: any[]=[];
  talentpoolnumber: any;
  noTalentpoolError: boolean;
  candidatenumber: any;
  talentErrorMessage: string;
  talentpoolid: any;
  sourcelist_data: any;
  resumeFile: any;
  resumeFileurl: any;


  constructor(private modalService: NgbModal, private fb: FormBuilder,
    private candidateservice: CandidateService, private searchtoolbox: SearchtoolboxService ,private talentpoolservice : TalentpoolService,
    private router : Router ,private _localstorageservice : LocalStorageService) { }

  ngOnInit() {
    this.events.subscribe((event: any) => {
      this.createcandidate_form = true
      this.getAllTalentpool()
    })

    this.candidate_form = this.fb.group({
      firstName: ['', Validators.compose([Validators.required,noWhitespaceValidator,Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      lastName: ['', Validators.compose([Validators.required,noWhitespaceValidator,Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      companyName: ['',Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      jobName: ['',Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      worklocation: ['',Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      publicProfileLink: ['', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      source: ['', [Validators.required,noWhitespaceValidator]],
      talentpoolname:['']
    })

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
  }
  }

  //For typeAhead Auto DropDown
  getautocompleteData(type,input): Observable<any> {
    let data ={
      "dropdowntype": type,
      "searchedstring": input
    }
    var subject = new Subject<any>();
    this.searchtoolbox.getAutoCompleteDataList(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        subject.next(res.data);
      }else{
        subject.next([])
      }
    })
    return subject.asObservable();
  }


  dismiss() {
    document.getElementById("mySidebar").style.display = "none";
    document.getElementById("myOverlay").style.display = "none";
    if(this.talentpoolid){
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['candidate-list/talentpool/'+this.talentpoolid]));
    }else if(this.candidatenumber){
      this.router.navigateByUrl('candidate-list', { skipLocationChange: true }).then(() =>
      this.candidateservice.passduplicatecandidateid(this.candidatenumber)
      // this.router.navigate(['candidate-list'])
      );
    }
  }

  modaldismiss() {
    this.dismiss();
    this.modalService.dismissAll();
    this.candidateservice.createCandidateData();
  }


  createCandidate() {
    if (this.candidate_form.valid) {
      this.modaldismiss();
      if(this.noTalentpoolError == false){
 
      let data = {
        firstname: this.candidate_form.value.firstName,
        middlename: '',
        lastname: this.candidate_form.value.lastName,
        companyname: this.candidate_form.value.companyName,
        jobtitle: this.candidate_form.value.jobName,
        locationname: this.candidate_form.value.worklocation,
        profileurl: this.candidate_form.value.publicProfileLink,
        source: this.candidate_form.value.source,
        usernumber : this._localstorageservice.getItem('usernumber')
      }
      this.candidateservice.checkduplicatecandidate(data).subscribe((res: any) => {
        if (res.status == 'success') {
          let duplicatecandidate = res.data.duplicatecandidate
          if (duplicatecandidate == true) {
            this.duplicatecandidateid = res.data.existingcandidatenumber
            const modalRef = this.modalService.open(this.duplicatecandidate, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
          }
          else {
            let data = {
              firstname: this.candidate_form.value.firstName,
              middlename: '',
              lastname: this.candidate_form.value.lastName,
              companyname: this.candidate_form.value.companyName,
              jobtitle: this.candidate_form.value.jobName,
              locationname: this.candidate_form.value.worklocation,
              profileurl: this.candidate_form.value.publicProfileLink,
              source: this.candidate_form.value.source, 
              usernumber : this._localstorageservice.getItem('usernumber')
            }
            this.candidateservice.createCandidate(data).subscribe((res: any) => {
              if (res.status == 'success') {
                this.candidate_form.reset()
                this.candidatenumber = res.data.createdcandidatenumber;
                if(res.data.createdcandidatenumber && this.talentpoolnumber ){
                  let talentpooldata = {
                    talentpoolnumber: this.talentpoolnumber,
                    insertobject: [{'candidatenumber' :  res.data.createdcandidatenumber}],
                    usernumber : this._localstorageservice.getItem('usernumber')
                  }
                  this.talentpoolservice.addCandidatetoTalentpool(talentpooldata).subscribe((res: any) => {
                    if (res.status == 'success') {
                      this.createcandidate_form = false
                    }else {
                      this.errorMessage = "Something Went Wrong"
                      const modalRef = this.modalService.open(this.errorModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
                    }
                  })
                }else{
                  this.createcandidate_form = false
                }
               
              } else {
                this.errorMessage = "Something Went Wrong"
                const modalRef = this.modalService.open(this.errorModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
              }
            }, (err) => { }, ()=>{
             if(this.resumeFile){
               let data ={
                candidatenumber : this.candidatenumber,
                cvfilesarray:[{
                  filename : this.resumeFile.filename,
                  docurl : this.resumeFile.docurl,
                  previewurl : this.resumeFile.previewurl,
                  isactive : 1
                }],
                cvactivitylog :[{
                  "action": "'added'",
                  "type": "'CV'",
                  "oldvalue": "'" + this.resumeFile.filename + "'",
                }]
               }
               this.candidateservice.savecvfiles(data).subscribe((res:any)=>{
                 if(res.status == 'failure'){
                  this.errorMessage = "Something went wrong while saving document"
                  const modalRef = this.modalService.open(this.errorModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
                 }
               })
             }
            })
          }
        }
      })
             
    }else{
      this.noTalentpoolError = true
    }
    }

    else {
      this.validateAllFormFields(this.candidate_form);
    } 
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }


  //Typeahead for JobTitles
  searchJobs() {
    this.candidate_form.controls['jobName'].valueChanges.subscribe((jobvalue: any) => {
    if (jobvalue != '' && jobvalue.length > 2 ) {
        this.getautocompleteData('job titles',jobvalue).subscribe((res)=>{
          this.joblist  = res
        })
      } else {
        this.joblist = []
      }
    })
  }

  //Typeahead for CompanyName
  searchCompany() {
    this.candidate_form.controls['companyName'].valueChanges.subscribe((companyvalue: any) => {
      if (companyvalue != '' && companyvalue.length > 2 && this.autocomplete_company) {
        this.autocomplete_company = false
        this.getautocompleteData('companies',companyvalue).subscribe((res)=>{
          this.companylist  = res.map(value => value['company_name'])
          this.autocomplete_company = true
        })
      } else {
        this.companylist = []
      }
    })
  }

  //Typeahead for Location
  searchLocation() {
    this.candidate_form.controls['worklocation'].valueChanges.subscribe((locationvalue: any) => {
      if (locationvalue != '' && locationvalue.length > 2 ) {
        this.getautocompleteData('locations',locationvalue).subscribe((res)=>{
          this.locationlist  = res
        })
      } else {
        this.locationlist = []
      }
    })
  }

  openDuplicateCandidateProfile(){
    this.modalService.dismissAll()
    if(this.router.url.includes('candidate-list')){
      document.getElementById("mySidebar").style.display = "none";
      document.getElementById("myOverlay").style.display = "none";
      this.candidateservice.passduplicatecandidateid(this.duplicatecandidateid)
    }else{
      this.router.navigateByUrl('/candidate-list?candidateid='+this.duplicatecandidateid)
    }
  }

  getAllTalentpool(){
    this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == "success") {
        this.talentpoolslist = res.data.talentpools.filter((x) =>{ return x.name.toLowerCase().includes(this.candidate_form.value.talentpoolname.toLowerCase()) });
          let talentpoolFound =  this.talentpoolslist.find(x => (x.name == this.candidate_form.value.talentpoolname));
          if(talentpoolFound == undefined && this.candidate_form.value.talentpoolname != ''){
            this.noTalentpoolError = true
          }else{
            this.noTalentpoolError = false
          }
      }
    })
  }

  getSourceList(){
    this.sourcelist_data = this.sourcelist.filter((x) =>{ return x.toLowerCase().includes(this.candidate_form.value.source.toLowerCase()) });
  }

  SaveTalent() {
    if(this.talentvalue !=null){
    let data = {
      "candidatenumber": this.candidatenumber,
      "usernumber": this._localstorageservice.getItem('usernumber'),
      "pipelinestatus": this.talentvalue,
      "activitylog": [
        {
          "action": "'update'",
          "tablename": "'candidate'",
          "type": "'pipeline status'",
          "updatedfieldname": "'pipelinestatus'",
          "oldvalue": "'Cold'",
          "newvalue": "'" + this.talentvalue + "'"
        }
      ]
    }
    this.candidateservice.updatepipelineStatus(data).subscribe((res: any) => {
      if (res.status == "success") {
        this.modalService.dismissAll();
        this.candidateservice.createCandidateData();
        this.successMessage = "Candidate Created Successfully"
        const modalRef = this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      }
      else {
        this.errorMessage = "Something Went Wrong"
        const modalRef = this.modalService.open(this.errorModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      }
    })}
    else{
      this.talentErrorMessage = 'Please Select Talent Status'
    }
  }


  
  openConfirmationModal(talentpool) {
    this.talentpoolnumber = talentpool.talentpoolnumber;
    this.talentpoolid = talentpool.talentpoolid;
  }

  uploadFile(e){
   let resumeFile = e.target.files[0]
   if(resumeFile.size > 5242880){
    this.filesizeExceeded = true
  }else{
    this.filesizeExceeded = false
  }
  if(!this.filesizeExceeded){
    this.filesizeExceeded = false
    this.candidateservice.uploadresume(resumeFile).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.resumeFile = res;
        e.target.value = ''
      }
    })
  }
  }

  removeFile(){
   let data ={
    documenturlsarray : [this.resumeFile.docurl , this.resumeFile.previewurl]
   }
   this.candidateservice.removeuploadeddocuments(data).subscribe((res:any)=>{
     if(res.status == 'success'){
      this.resumeFile = null
     }
   })
  }
}
